import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    appBarSpacer: theme.mixins.toolbar,
    container: {
        justifyContent: 'center',
        // marginLeft: theme.spacing(8),
        margin: '0 auto',
        paddingBottom: theme.spacing(4),
        paddingTop: theme.spacing(4),
    },
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
        margin: '0 auto',
    },
    contentWrapper: {
        marginTop: theme.spacing(4),
    },
    fabContainer: {
        overflow: 'visible',
        position: 'relative',
    },
    fixedHeight: {
        height: 240,
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        padding: theme.spacing(2),
    },
    root: {
        display: 'flex',
        justify: 'center',
    },
    sidePadding: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
}));
